var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTotalOrder({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12H34.5H9.5ZM9.5 22H34.5H9.5ZM14.5 32H29.5H14.5ZM2 2H42V42H2V2Z",
    fill: "#D9D9D9",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 12H34.5M9.5 22H34.5M14.5 32H29.5M2 2H42V42H2V2Z",
    stroke: "#221C35",
    strokeOpacity: 0.3,
    strokeWidth: 3.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalOrder);
export default __webpack_public_path__ + "static/media/total_order.5214f9fb14fba74f0fd00cb124244b88.svg";
export { ForwardRef as ReactComponent };